<template lang="pug">
.layout
  .container
    .container-content(:class="{'error' : errors.has(getFieldName('Documento'))}")
      app-label(label="Tipo de documento:", :required="validateDocumentos")
      el-select.input.select(
        data-vv-validate-on="change",
        v-model='tipoDocumento',
        placeholder='Selecione o documento...',
        name="Tipo de documento",
        v-validate="'required'",
        :data-vv-scope="scopeFields",
        :class="{'erro' : errors.has(getFieldName('Tipo de documento'))}",
        :disabled="loading"
        @change="handleTipoChanged"
      )
        el-option(
          v-for='item in tiposDocumentos',
          :key='item.codigo',
          :label='item.descricao',
          :value='item.codigo'
        )
      p.help.erro(v-show="errors.has(getFieldName('Tipo de documento'))") {{ errors.first(getFieldName('Tipo de documento')) }}

    .container-content
      app-label(label="Documento:", :required="validateDocumentos")
      el-input.input#fileName(
        data-vv-validate-on="change",
        v-model="fileName",
        name="Documento",
        v-validate="'required'",
        :data-vv-scope="scopeFields",
        :class="{'erro' : errors.has(getFieldName('Documento'))}",
        readonly
      )
        el-button(
          slot='append',
          icon='el-icon-search',
          @click="callEventClick()",
          :disabled="loading"
        )
      p.help.erro(v-show="errors.has(getFieldName('Documento'))") {{ errors.first(getFieldName('Documento')) }}

    .button-anexo(:class="{'error' : errors.has(getFieldName('Documento'))}")
      app-button(
        tipo="success",
        icone="far fa-paperclip",
        titulo="Anexar",
        @anexaDocumento="addDocumento()",
        size="large",
        method="anexaDocumento",
        :loading="loading"
      )

  el-row
    el-col(:md="24", :lg="24", :xl="24")
      input(
        type='file',
        @change="setDocument",
        :id="scope",
        ref="eventoClick",
        multiple="false",
        :accept="validExtensions",
        style="display:none"
      )

</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'
import AppButton from './AppButton'
import AppLabel from './AppLabel'
import AppNotificacao from './mixins/AppNotificacao'

export default {

  inject: ['$validator'],

  mixins: [
    AppNotificacao
  ],

  components: {
    AppButton,
    AppLabel
  },

  props: {
    scope: {
      type: String,
      required: false
    },
    modulo: {
      type: String,
      required: false
    },
    validExtensions: {
      type: Array,
      required: false
    },
    maxSize: {
      type: Number,
      required: false
    },
    validateDocumentos: {
      type: Boolean,
      required: false
    },
    mutationAddDocumento: {
      type: String,
      required: false
    },
    getterTiposDocumentos: {
      type: String,
      required: false
    },
    findTiposDocumento: {
      type: String,
      required: false
    },
    validateCampos: {
      type: Object,
      default: null
    },
    validationName: {
      type: String
    }
  },

  computed: {
    tiposDocumentos () {
      return this.$store.getters[`documentos/${this.getterTiposDocumentos}`]
    },
    scopeFields () {
      return `${this.scope}Fields`
    }
  },

  data () {
    return {
      fileName: '',
      fileUpload: {},
      tipoDocumento: '',
      loading: false
    }
  },

  created () {
    this.$store.dispatch(`documentos/${this.findTiposDocumento}`)
  },

  methods: {
    ...mapActions({
      uploadDocumentos: 'documentos/upload'
    }),

    callEventClick () {
      this.$refs.eventoClick.click()
    },

    setDocument () {
      const input = document.getElementById(this.scope)
      const file = input.files[0]
      if (file === undefined) {
        return
      }
      if (!this.validateArquivo(file)) {
        input.value = ''
        return
      }

      const blob = file.slice(0, file.size, file.type)
      const newFile = new File([blob], file.name.normalize('NFD').replace(/[\u0300-\u036f]/g, ''), { type: file.type })

      this.fileUpload = newFile
      this.fileName = newFile.name
      input.value = ''
    },

    async addDocumento () {
      const result = await this.$validator.validateAll(`${this.scopeFields}`)
      if (result) {
        this.loading = true
        this.uploadDocumentos(this.fileUpload).then((key) => {
          this.$store.commit(`${this.modulo}/${this.mutationAddDocumento}`, {
            key,
            nome: this.fileName,
            tipoDocumento: _.find(this.tiposDocumentos, tipo => tipo.codigo === this.tipoDocumento)
          })
          this.loading = false
          this.fileUpload = {}
          this.fileName = ''
          this.tipoDocumento = ''
          this.addValidateDocumentos()
          this.$validator.validate(`${this.scope}.Documentos`)
          this.$validator.detach('Documentos', this.scope)
        }).catch(() => {
          this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
            this.$messages.ARQUIVO_NOME_INVALIDO)
          this.loading = false
        })

        const error = _.find(this.errors.items, error => error.field === 'Documentos')
        if (error) {
          this.$validator.validate(`${this.scope}.Documentos`)
        }
      }
    },

    addValidateDocumentos () {
      this.$validator.attach({
        name: 'Documentos',
        getter: () => this.validateCampos,
        rules: this.validationName,
        scope: this.scope
      })
    },

    removeDocumento (anexo) {
      this.confirmBox(this.$messages.DOCUMENTO_REMOVE_CONFIRM, this.$messages.TITULO_WARNING,
        () => {
          this.$store.commit(`${this.modulo}/REMOVE_ANEXO`, {
            anexo,
            mensagem: this.mensagem
          })
          this.$validator.validate(`${this.scope}`)
        },
        () => { }
      )
    },

    validateArquivo (file) {
      let fileExtension = `.${file.name.split('.').pop()}`
      fileExtension = fileExtension.toLowerCase()
      if (!_.find(this.validExtensions, extension => fileExtension === extension)) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
          this.$messages.ARQUIVO_EXTENSION_FAIL.replace('$$', this.validExtensions.join(', ')))
        return false
      }
      const isLtMaxSize = file.size < this.maxSize * 1048576
      if (!isLtMaxSize) {
        this.showNotificacao(this.$messages.TIPO_WARNING, this.$messages.TITULO_WARNING,
          this.$messages.ARQUIVO_SIZE_FAIL.replace('$$', this.maxSize))
        return false
      }
      return true
    },

    getFieldName (fieldName) {
      return `${this.scopeFields}.${fieldName}`
    },

    handleTipoChanged (value) {
      const tipoSelecionado = this.tiposDocumentos.find(tipo => tipo.codigo === value)
      this.$emit('tipoChanged', tipoSelecionado)
    }
  }
}
</script>

<style scoped lang="scss">
  .select {
    margin-top: 2px;
    width: 100%;
  }

  .container {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;

    .container-content {
      width: 45%;

      &:first-child.error {
        height: 124px;
      }
    }

    .button-anexo {
      align-self: flex-end;

      &.error {
        align-self: center;
        margin-top: 15px;
      }
    }
  }

  @media (max-width: 1365px) {
    .container .container-content {
      width: 43%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/AppUploadDocumentosAnexar.vue